<script>
import { bookingsMapper } from '@/mappers/bookings-mapper.js'
export default {
  name: 'CandidateBookings',
  props: {
    bookings: {
      type: Array,
      default: null,
    },
    timeZone: {
      type: String,
      default: null,
    },
  },
  methods: {
    mapBookings() {
      return bookingsMapper(this.bookings, this.timeZone)
    },
  },
}
</script>

<template>
  <v-card class="pa-10" flat>
    <div
      v-for="(y, i) in mapBookings()"
      :key="`bookingMapper_booking_${y + i}`"
    >
      <div class="grouped-year">
        <h4 class="text-center">
          {{ y.year }}
        </h4>
        <div
          v-for="(m, j) in y.months"
          :key="`bookingMapper_month_${m + j}`"
          class="grouped-month"
        >
          <div class="group-subtitle">
            <div class="flex-row">
              <div class="title-text">
                <v-badge
                  inline
                  dark
                  class="black--text"
                  color="green"
                  :content="m.days.length"
                >
                  <div>
                    {{ m.month }}
                  </div>
                </v-badge>
              </div>
            </div>
            <div class="title-chart">
              <div
                v-for="(s, k) in m.xseries"
                :key="`bookingMapper_day_${s + k}`"
                :class="[s === 'bk-booked' ? 'bk-booked' : 'bk-day']"
              >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<style lang="scss" scoped>
@import '@styles';
.bk-day {
  background-color: #eee !important;
}

.bk-booked {
  background-color: #00acef !important;
}

.group-subtitle {
  display: flex;
  font-size: 14px;
  font-weight: 600;
}
.title-chart {
  display: flex;
  width: 90%;
  height: 10px;
  margin-top: 5px;
  margin-left: 5%;
}

.title-chart div {
  flex-grow: 1;
  width: 1%;
  margin: 1px;
}

.title-text {
  width: 10%;
  min-width: 60px;
  text-align: left;
  white-space: nowrap;
}

.grouped-year {
  padding: 10px;
  margin-bottom: 10px;
}

.grouped-month {
  padding-top: 3px;
  margin-bottom: 5px;
  .booking {
    display: inline-block;
    float: left;
    width: 90px;
    padding: 5px;
    margin-right: 10px;
    margin-bottom: 10px;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 3px;

    .day {
      display: block;
      padding: 0;
      margin: 0;
      font-size: 1em;
      line-height: 1em;
    }

    .number {
      display: block;
      padding: 0;
      margin: 0;
      font-size: 1.4em;
      font-weight: 600;
      line-height: 1.4em;
    }

    .booking-id {
      padding: 0;
      margin: 0;
      opacity: 0.7;
    }
  }
}
</style>
